/* unplugin-vue-components disabled */import { render } from "./SpecialIndex.vue?vue&type=template&id=7ebc98fe"
import script from "./SpecialIndex.vue?vue&type=script&lang=js"
export * from "./SpecialIndex.vue?vue&type=script&lang=js"

import "./SpecialIndex.vue?vue&type=style&index=0&id=7ebc98fe&lang=css"

import exportComponent from "D:\\project\\ad\\ad-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__